import React from 'react';
import { CheckCircle2Icon } from './icons';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { checkoutUrl, heroImage, valueStack } from '../data/copy';
const badges = ['Immediate access', 'Secure payment', '7-day guarantee'];
export function OfferSection() {
  return <section id="offer" className="w-full scroll-mt-6 bg-charcoal py-7 sm:py-12" aria-labelledby="offer-heading" data-id="element-141" data-mp="df6r606nmpfp">
      <div className="mx-auto max-w-xl px-5 sm:px-6" data-id="element-142" data-mp="ifazv41bmfvd">
        <div className="text-center" data-id="element-143" data-mp="mds9bu87s2fy">
          <p className="eyebrow text-rose" data-id="element-144" data-mp="mgwlbdrx82h6">The complete package</p>
          <h2 id="offer-heading" className="mx-auto mt-2 max-w-md font-display text-2xl leading-tight text-cream sm:mt-3 sm:text-4xl" data-id="element-145" data-mp="rf7udmae68yc">
            Everything You Need For Your Next Class
          </h2>
        </div>

        <div className="mt-4 rounded-4xl border border-gold/40 bg-cream p-4 shadow-soft sm:mt-7 sm:p-7" data-id="element-146" data-mp="2y4cp8ztg1svy">
          <div className="rounded-2xl bg-blush px-2 py-2 sm:rounded-3xl sm:px-4 sm:py-3" data-id="element-147" data-mp="12n8k3ov69ojk">
            <img src={heroImage} alt="Everything included: the 6 master volumes, 7 bonus books and printable planners." className="mx-auto w-full max-w-[280px] sm:max-w-[380px]" width={1240} height={1240} loading="lazy" data-id="element-148" data-mp="xws6a3nfw0wo" />
          </div>

          <ul className="mt-3 sm:mt-5" data-id="element-149" data-mp="1lmmjwnfl1thz">
            {valueStack.map(line => <li key={line.label} className="flex items-baseline justify-between gap-4 border-b border-charcoal/10 py-1.5 sm:py-2.5" data-id="element-150" data-mp="1gmrs8hnzgzvv">
                <span className="font-sans text-[0.72rem] leading-snug text-ash sm:text-[0.8rem]" data-id="element-151" data-mp="17mlh32frcbzv">
                  {line.label}
                </span>
                <span className="font-display text-base text-charcoal sm:text-lg" data-id="element-152" data-mp="17avxbdihqon">
                  {line.value}
                </span>
              </li>)}
            <li className="flex items-baseline justify-between gap-4 py-2" data-id="element-153" data-mp="3tthkkg5xie0z">
              <span className="eyebrow text-charcoal/70" data-id="element-154" data-mp="2noivpivo7ls">Regular price</span>
              <span className="font-display text-xl text-charcoal sm:text-2xl" data-id="element-155" data-mp="2llvzed0uula">
                $97
              </span>
            </li>
          </ul>

          <CountdownTimer data-id="element-156" data-mp="3ou4yhxmvtazg" />

          <div className="mt-2.5 rounded-2xl border border-gold/40 bg-blush px-5 py-4 text-center sm:rounded-3xl sm:py-5" data-id="element-157" data-mp="3otbu33beaxkh">
            <p className="font-sans text-[11px] text-ash" data-id="element-158" data-mp="3b1ouati8v6wy">
              Instead of{' '}
              <span className="line-through decoration-rose-deep" data-id="element-159" data-mp="3fwb8t5jmhfl9">$97</span>
            </p>
            <p className="mt-1.5 eyebrow text-goldink" data-id="element-160" data-mp="31759lhksbpdd">Your price today</p>
            <p className="mt-0.5 flex items-start justify-center gap-1 font-display text-[3.25rem] leading-none text-wine sm:text-[4rem]" data-id="element-161" data-mp="3656rw0adzkns">
              <span className="mt-2 text-xl sm:text-2xl" data-id="element-162" data-mp="2s702l8ji6szq">$</span>27
            </p>
            <p className="mt-2 inline-block rounded-full bg-wine px-3.5 py-1 font-sans text-[10px] font-semibold uppercase tracking-[0.14em] text-cream" data-id="element-163" data-mp="2x2xgl87ann9c">
              Save 72% — launch special
            </p>
          </div>

          <CtaButton href={checkoutUrl} className="mt-3 w-full py-4 sm:py-5" data-id="element-164" data-mp="2min31zc0cpyg">
            Get instant access — $27
          </CtaButton>

          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 sm:mt-5 sm:gap-x-5" data-id="element-165" data-mp="2ifyt1obk5czw">
            {badges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-ash" data-id="element-166" data-mp="2wegf7hltehfp">
                <CheckCircle2Icon className="h-3.5 w-3.5 text-goldink" strokeWidth={1.7} aria-hidden="true" data-id="element-167" data-mp="365ktef3o1y9h" />
                {badge}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}